import React, { createContext, useState } from "react";

export const AuthContext = createContext({ userAuth: false, setUserAuth: () => {} });

const UserContext = ({ children }) => {
  const [userAuth, setUserAuth] = useState(false);

  return (
    <AuthContext.Provider value={{ userAuth, setUserAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default UserContext;
